var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"db__footer",attrs:{"height":"300px"}},[_c('v-container',[_c('p',{staticClass:"text-sm-center color-white"},[_vm._v("\n                Footer Stuff here\n            ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }